var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ck-tab',{staticClass:"application-tab",attrs:{"items":_vm.tabItems,"layout":"button"},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}})}
var staticRenderFns = []

export { render, staticRenderFns }